import api from "./api";

export default {
  getByProduto: (produtoId) => api.get(`/produtos/${produtoId}/precos`),
  create: (data) =>
    api.post(`/produtos/${data.produto_id}/precos`, { preco: data }),
  update: (id, data) => api.put(`/produto_precos/${id}`, { preco: data }),
  getVigente: (produtoId, data) =>
    api.get("/produto_precos/vigente", {
      params: { produto_id: produtoId, data },
    }),
};
